import { array, partial } from 'io-ts/Decoder';

import { constants } from '@bedc/constants';

import { PartialRequest as DefinitePartialRequest } from '../../api/generic/pagination/definite/Request';
import { Request as SortRequest } from '../../api/generic/search/sort/Request';
import { ColumnField as TransactionColumnField } from '../../transaction/search/ColumnField';
import { ColumnField as JobColumnField } from '../search/ColumnField';

import { SettingsFilters } from './SettingsFilters';

export const Settings = partial({
	filters: SettingsFilters,
	// TODO: Group by.
	hiddenColumns: partial({
		job: array(JobColumnField),
		trx: array(TransactionColumnField),
	}),
	sort: partial({
		job: SortRequest(constants.job.search.sortFields),
		trx: SortRequest(constants.transaction.search.sortFields),
	}),
	pagination: partial({
		job: DefinitePartialRequest,
		trx: DefinitePartialRequest,
	}),
});
